import { Component, Input } from '@angular/core';
import { DatagridActionHandler, Unsubscriber } from '@core-lib/classes';
import { IDatagridSettings, IDatagridSort, IList } from '@core-lib/models';

@Component({
    selector: 'datagrid-table',
    template: '',
    standalone: false
})
export class DatagridTableComponent<Item, SortableCols> extends Unsubscriber {
	@Input() datagridHandler: DatagridActionHandler<SortableCols>;
	@Input() list: IList<Item>;
	@Input() settings: IDatagridSettings<SortableCols>;

	sortableCols;

	constructor() {
		super();
	}

	onSetSort(column: SortableCols): void {
		const currentSort = this.settings.sort;
		const isSameCol = column === currentSort.column;

		const sort: IDatagridSort<SortableCols> = {
			column,
			isAsc: isSameCol ? !currentSort.isAsc : true
		};

		this.datagridHandler.setSort(sort);
	}

	getSortClasses(column: SortableCols): object {
		const currentSort = this.settings.sort;
		const isSameCol = column === currentSort.column;

		return {
			'col-sorted-asc': isSameCol && currentSort.isAsc,
			'col-sorted-desc': isSameCol && !currentSort.isAsc
		};
	}
}
